export default "__VITE_ASSET__BoF3kgyG__"